import Box from "@mui/material/Box"
import Button from "@mui/material/Button"
import Typography from "@mui/material/Typography"
import { useState } from "react"
import { useNavigate } from "react-router-dom"

import { axiosClient } from "../../../common/axios"
import PasswordTextField from "../../../common/components/PasswordTextField"
import TextLink from "../../../common/components/TextLink"
import LoadingPaper from "../components/LoadingPaper"
import PageTitle from "../components/PageTitle"

export default function ResetPassword() {
  const [password, setPassword] = useState("")
  const [passwordError, setPasswordError] = useState(null)
  const [password2, setPassword2] = useState("")
  const [password2Error, setPassword2Error] = useState(null)
  const [hasKeyError, setHasKeyError] = useState(false)
  const [isLoading, setIsLoading] = useState(false)

  function handlePasswordChanged(e) {
    setPassword(e.target.value)
    setPasswordError(null)
    setPassword2Error(null)
  }

  function handlePassword2Changed(e) {
    setPassword2(e.target.value)
    setPasswordError(null)
    setPassword2Error(null)
  }

  function handleResetPasswordButtonClicked() {
    setIsLoading(true)
    const queryParams = new URL(window.location.href).searchParams
    axiosClient
      .post("/users/api/password/reset/", {
        password_1: password,
        password_2: password2,
        key: queryParams.get("key"),
        uidb36: queryParams.get("uidb36"),
      })
      .then(() => navigate("/user/log-in"))
      .catch(({ response: { data } }) => {
        if (data.password_1) {
          setPasswordError(data.password_1.join("\n"))
        } else if (data.password_2) {
          setPassword2Error(data.password_2)
        } else if (data.key) {
          setHasKeyError(true)
        }
      })
      .then(() => setIsLoading(false))
  }

  const navigate = useNavigate()

  return (
    <>
      <PageTitle text="Reset your account password" />
      <Box sx={{ mt: (theme) => theme.spacing(2) }}>
        <LoadingPaper isLoading={isLoading}>
          {hasKeyError && (
            <Typography
              variant="body1"
              sx={{
                color: (theme) => theme.palette.error.main,
                mb: (theme) => theme.spacing(2),
              }}
            >
              Password reset link is invalid or expired. Click{" "}
              <TextLink to="/user/forgot-password" text="here" /> to get a new
              link.
            </Typography>
          )}
          <PasswordTextField
            label="Password"
            size="small"
            value={password}
            onChange={handlePasswordChanged}
            required
            error={!!passwordError}
            helperText={passwordError}
            fullWidth
          />
          <PasswordTextField
            label="Confirm password"
            size="small"
            value={password2}
            onChange={handlePassword2Changed}
            required
            error={!!password2Error}
            helperText={password2Error}
            sx={{ mt: (theme) => theme.spacing(2) }}
            fullWidth
          />
          <Button
            variant="contained"
            disabled={!password || !password2}
            onClick={handleResetPasswordButtonClicked}
            sx={{ mt: (theme) => theme.spacing(4) }}
          >
            Reset Password
          </Button>
          <Typography variant="body1" sx={{ mt: (theme) => theme.spacing(2) }}>
            Remembered your original password?{" "}
            <TextLink to="/user/log-in" text="Log in" />.
          </Typography>
        </LoadingPaper>
      </Box>
    </>
  )
}
